import React from 'react'
import './Notify.css'
import {Social2Header} from '../../../components'


const Notify = () => {
  return (
    <>
    <Social2Header/>
  
    Notify
    </>
  )
}

export default Notify
